export const STATUS_TRANSLATION = {
    canceled: 'cancelada',
    changed: 'alterada',
    executed: 'executada',
    expired: 'expirada',
    hung: 'aberta',
    partially_executed: 'executada parcialmente',
    pending_cancel: 'cancelada pendente',
    pending_change: 'alterada pendente',
    pending_hung: 'aberta pendente',
    previous_final_state: 'estado final anterior',
    received: 'recebida',
    rejected: 'rejeitada',
    suspended: 'suspensa',
    triggered: 'disparada',
    unknown: 'desconhecido'
};
export const ACTION_TRANSLATION = {
    0: 'C',
    1: 'V'
};
export const ORDER_TYPE_TRANSLATION = {
    entry: 'Entrada',
    exit: 'Saída',
    reversal: 'Reversão'
};
//# sourceMappingURL=translations.js.map